import { HeaderBar } from '@fortem-monorepo/react-spa'

import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { AddFundEntryModal } from '@/components/dialogs/AddFundEntryModal'
import { FUNDS_LINKS } from '@/constants/links'
import { fundsContext, useCreateFundsContext } from '@/pages/funds/funds-context.context'

export interface FundsLayoutProps {}

export const FundsLayout: React.FC<FundsLayoutProps> = ({}) => {
  const context = useCreateFundsContext()

  return (
    <fundsContext.Provider value={context}>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={FUNDS_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <LayoutOutlet />
      {/* Modals */}
      <AddFundEntryModal />
    </fundsContext.Provider>
  )
}
